import { getDates } from '@zenos/front-end-util-utils';
import type { ActionProps, StateProps } from './types.ts';

export const today = new Date();
const { startDate } = getDates(today);

export const initialState: StateProps = {
  date: {
    selectedDate: today,
    startOfWeek: startDate,
  },
  device: { mobile: false, desktop: false },
  selectedUser: undefined,
  isLoadingPermissions: true,
  errorMessage: null,
  year: today.getFullYear(),
  month: today.getMonth() + 1,
};

export function reducer(state: StateProps, action: ActionProps) {
  switch (action.type) {
    case 'SET_DATE':
      return { ...state, date: action.payload };
    case 'SET_DEVICE_TYPE':
      return { ...state, mediaQuery: action.payload };
    case 'SET_SELECTED_USER':
      return { ...state, selectedUser: action.payload };
    case 'SET_IS_LOADING_PERMISSIONS':
      return { ...state, isLoadingPermissions: action.payload };
    case 'SET_ERROR_MESSAGE':
      return { ...state, errorMessage: action.payload };
    case 'SET_YEAR':
      return { ...state, year: action.payload };
    case 'SET_MONTH':
      return { ...state, month: action.payload };
    default:
      return state;
  }
}
